import React from 'react';
import { getFlowNode } from './Flow.ts';
import { useAppState } from './State.tsx';
import ChoiceStep from './Components/Flow/ChoiceStep.tsx';
import ResultStep from './Components/Flow/ResultStep.tsx';
import ContentOptionStep from './Components/Flow/ContentOptionStep.tsx';
import InputStep from './Components/Flow/InputStep.tsx';

const StepRouter = () => {
  const { currentNodeId } = useAppState();
  const node = getFlowNode(currentNodeId);

  if (node.kind === 'contentOption') {
    return <ContentOptionStep node={node} key={node.id} />;
  }

  if (node.kind === 'input') {
    return <InputStep node={node} />;
  }

  if (node.kind === 'choice') {
    return <ChoiceStep node={node} />;
  }

  return <ResultStep node={node} />;
};

export default StepRouter;
